import { EllipsisMenuOption } from "./components/EllipsisMenuList";
import MoovsEllipsisMenu from "./MoovsEllipsisMenu";

export default MoovsEllipsisMenu;
export type { EllipsisMenuOption };
